import React, { useEffect } from 'react'
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router';

const Public = ({ Component }) => {
    const navigate = useNavigate();
    const { userInfo } = useSelector((store) => store.user);
    useEffect(() => {
        if (userInfo.userId) {
            navigate("/")
        }
    }, [userInfo.userId]);
    return (
        <>
            {!userInfo.userId && <Component />}
        </>
    )
}

export default Public